import React from 'react';
import PropTypes from 'prop-types';
import { CheckboxGroup } from '@opendate-app/setlist';

const GiftRenewalChoice = ({ keepPaying, onChange, interval, productName, recipientName, priceLabel }) => {
  const unit = interval === 'month' ? 'month' : 'year';
  const recipient = recipientName.trim() || 'your friend';

  return (
    <div style={{ marginTop: "15px" }}>
      <p className="mb-2" style={{ fontSize: "14px" }}><strong>After the first {unit}</strong></p>
      <CheckboxGroup
        type="radio"
        name="gift-renewal"
        aria-label={`After the first ${unit}`}
        value={keepPaying ? 'keep-paying' : 'one-time'}
        onChange={(next) => onChange(next === 'keep-paying')}
        items={[
          {
            value: 'one-time',
            label: 'One-time gift',
            supportingText: `1 ${unit} of ${productName}. It doesn't renew. Before it ends we'll invite ${recipient} to continue on their own card.`
          },
          {
            value: 'keep-paying',
            label: "I'll keep paying",
            supportingText: `Renews on your card at ${priceLabel}/${unit} until you or ${recipient} turn it off. We'll remind you before each renewal.`
          }
        ]}
      />
    </div>
  );
};

GiftRenewalChoice.propTypes = {
  keepPaying: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  interval: PropTypes.oneOf(['month', 'year']).isRequired,
  productName: PropTypes.string.isRequired,
  recipientName: PropTypes.string.isRequired,
  priceLabel: PropTypes.string.isRequired
};

export default GiftRenewalChoice;
